var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sosmed)?_c('div',{staticClass:"popup-wa"},[_c('a',{staticClass:"float",attrs:{"title":"'Hubungi Admin '","href":`https://api.whatsapp.com/send?phone=62${_vm.sosmed.whatsapp}&text=Halo+Admin+saya+ingin+bertanya`,"target":"_blank"}},[_c('font-awesome-icon',{staticClass:"my-float",attrs:{"icon":"fa-brands fa-whatsapp "}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }